import moment from 'moment-timezone';

export const formatDateTimeTz = (date, tz) => moment.tz(date, tz).format('MM/DD/YYYY  -  h:mmA')

export const formatTimeTz = (date, tz) => moment.tz(date, tz).format('h:mmA');

export const formatTableDateTz = (date, tz) => moment.tz(date, tz).format('MM/DD/YY');

export const meridiemTo24 = (hour = '') => {
  const [time, meridiem] = hour.split(' ');
  const [hours, minutes] = time.split(':');

  if (!hours || !minutes) {
    return '';
  }

  if (meridiem === 'PM' && parseInt(hours) < 12) {
    return `${parseInt(hours) + 12}:${minutes}`;
  }

  if (meridiem === 'AM' && parseInt(hours) === 12) {
    return `00:${minutes}`;
  }

  return `${hours.padStart(2, '0')}:${minutes}`;
};

export const hour24ToMeridiem = (hour = '') => {
  const [hours, minutes] = hour.split(':');

  if (!hours || !minutes) {
    return '';
  }

  if (parseInt(hours) === 0) {
    return `12:${minutes} AM`;
  }

  if (parseInt(hours) === 12) {
    return `12:${minutes} PM`;
  }

  if (parseInt(hours) > 12) {
    return `${parseInt(hours) - 12}:${minutes} PM`;
  }

  return `${parseInt(hours)}:${minutes} AM`;
};
